// frontend/src/pages/SupportProject.js
import { useNavigate } from "react-router-dom";

import PageContainer from "../components/layout/PageContainer";
import GlassPanel from "../components/layout/GlassPanel";
import BackButton from "../components/layout/BackButton";
import PackageGrid from "../components/support/PackageGrid";

import { SUPPORT_PACKAGES } from "../data/supportPackages";

import { trackPackageSelect, trackSupportClick } from "../analytics/analytics";

export default function SupportProject() {
  const navigate = useNavigate();

  function handleSelect(pkg) {
    trackPackageSelect(pkg.id, pkg.name, pkg.price);

    trackSupportClick("package_card");

    navigate("/payment", {
      state: {
        packageData: pkg,
      },
    });
  }

  return (
    <PageContainer>
      <div
        style={{
          width: "100%",
          maxWidth: 1200,
        }}
      >
        <BackButton to="/" />

        <GlassPanel>
          <h1
            style={{
              textAlign: "center",
              fontSize: 54,
              marginTop: 0,
            }}
          >
            Support Elacoria
          </h1>

          <PackageGrid packages={SUPPORT_PACKAGES} onSelect={handleSelect} />
        </GlassPanel>
      </div>
    </PageContainer>
  );
}
